import type { ReactNode } from "react";
import { useRef } from "react";
import dynamic from "next/dynamic";
import { Grid, GridItem } from "@chakra-ui/react";
import AppHead from "components/app/app-head";
import AppHeader from "components/app/app-header/app-header";
import AppDrawer from "components/app/app-nav/app-drawer";
import useSidebarLinks from "components/app/app-nav/app-links";
import AuthWrapper from "components/app/auth-wrapper/auth-wrapper";

const SessionObjectiveModal = dynamic(
  () => import("components/app/session-objective-modal"),
  { ssr: false }
);

interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const drawerButtonRef = useRef<HTMLButtonElement>();

  const sidebarLinks = useSidebarLinks();

  return (
    <AuthWrapper>
      <Grid
        className="app-layout"
        h="100%"
        templateColumns="1fr"
        templateRows="56px 1fr"
        gap={0}
        overflow="hidden"
      >
        <AppHead />
        <AppHeader drawerButtonRef={drawerButtonRef} />
        <AppDrawer
          drawerButtonRef={drawerButtonRef}
          sidebarLinks={sidebarLinks}
        />
        <GridItem as="main" bg="slate.100" overflow="hidden">
          {children}
        </GridItem>
        <SessionObjectiveModal />
      </Grid>
    </AuthWrapper>
  );
};

export default AppLayout;
